import { call, put, takeLatest } from "redux-saga/effects";

import { PatientsAPI } from "../../../api/patientsAPI";
import {
  DELETE_MEDICATION_REQUEST,
  DELETE_MEDICATION_SUCCESS,
  DELETE_MEDICATION_ERROR,
  SET_TOAST
} from "../../actions";
import {ToastType} from "../../../utils/interfaces";

function* workerDeleteMedication({
  type,
  payload: { medicationId, patientId },
}: {
  type: string;
  payload: {
    medicationId: any;
    patientId: any;
  };
}): Generator<any> {
  try {
    const data: any = yield call(PatientsAPI.deleteMedication, patientId, medicationId);

    yield put({
      type: DELETE_MEDICATION_SUCCESS,
      payload: { defaultMedications: data }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Medication was deleted successfully",
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    yield put({
      type: DELETE_MEDICATION_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Something went wrong",
        type: ToastType.ERROR,
      }
    });
  }
}

export function* watcherDeleteMedication() {
  yield takeLatest(DELETE_MEDICATION_REQUEST, workerDeleteMedication);
}
